export { ProductDetails } from './product-details'
